import {UIDeviceInfoPopup} from '../../../shared/scripts/ui_popup/UIDeviceInfoPopup.tsx'
import {StorageWrapper} from '../../../shared/scripts/StorageWrapper.ts'
import {UIDeviceController} from '../../../shared/scripts/ui_html/UIDeviceController.ts'

export class UIMDeviceInfoPopup extends UIDeviceInfoPopup {
    constructor() {
        const isMobileWebBrowser = UIDeviceController.isUserOnMobileWebBrowser()
        const buildNumber = isMobileWebBrowser ? '' : `<b>Build Number: </b> ${StorageWrapper.getBuildNumber()}  <br/>`
        const gameOrientation = `<b>PortraitMode: </b> ${StorageWrapper.isPortraitGamePlayEnabled()}  <br/>`
        const platform = isMobileWebBrowser ? '' : `<b>Platform: </b> ${StorageWrapper.getPlatform()}  <br/>`
        const statusBarHeight = `<b>StatusBarHeight: </b> ${StorageWrapper.getStatusBarHeight()} <br/>`
        const bottomArea = `<b>SafeAreaInsetBottom: </b> ${StorageWrapper.getSafeAreaInsetBottom()} <br/>`
        super(buildNumber + gameOrientation + platform + statusBarHeight + bottomArea)
    }
}
